import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

export const NotAuthenticatedGuard: CanMatchFn = async (
  route: Route,
  segments: UrlSegment[]
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.user()) {
    router.navigateByUrl('/');
    return false;
  }

  const isAuthenticated = await firstValueFrom(authService.checkStatus());

  if (isAuthenticated) {
    router.navigateByUrl('/');
    return false;
  }

  // Si el access caducó pero el refresh sigue válido, la sesión se recupera
  // sola y se entra directo en lugar de mostrar el login
  const renewed = await firstValueFrom(authService.refreshToken());

  if (renewed) {
    router.navigateByUrl('/');
    return false;
  }

  return true;
};
